module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert-thresholds-inline fba-thresholds-inline"
  }, [_c('div', {
    staticClass: "fba-inline-title"
  }, [_c('i', {
    staticClass: "cog icon"
  }), _vm._v(" "), _c('span', [_vm._v("Alert Thresholds — " + _vm._s(_vm.productTitle) + " · " + _vm._s(_vm.marketplaceLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-fields"
  }, [_c('div', {
    staticClass: "fba-inline-field"
  }, [_c('label', [_vm._v("Warning (units)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.amberThreshold),
      expression: "form.amberThreshold",
      modifiers: {
        "number": true
      }
    }],
    class: ['fba-inline-input', _vm.inputFilledClass(_vm.form.amberThreshold)],
    attrs: {
      "type": "number",
      "min": "-1",
      "placeholder": "—",
      "disabled": !_vm.resolvedProductId
    },
    domProps: {
      "value": (_vm.form.amberThreshold)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amberThreshold", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fba-field-hint"
  }, [_vm._v("units left")])]), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-field"
  }, [_c('label', [_vm._v("Alert (units)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.redThreshold),
      expression: "form.redThreshold",
      modifiers: {
        "number": true
      }
    }],
    class: ['fba-inline-input', _vm.inputFilledClass(_vm.form.redThreshold)],
    attrs: {
      "type": "number",
      "min": "-1",
      "placeholder": "—",
      "disabled": !_vm.resolvedProductId
    },
    domProps: {
      "value": (_vm.form.redThreshold)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "redThreshold", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fba-field-hint"
  }, [_vm._v("units left")])]), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-field"
  }, [_c('label', [_vm._v("Warning (days)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.amberDays),
      expression: "form.amberDays",
      modifiers: {
        "number": true
      }
    }],
    class: ['fba-inline-input', _vm.inputFilledClass(_vm.form.amberDays)],
    attrs: {
      "type": "number",
      "min": "-1",
      "placeholder": "—",
      "disabled": !_vm.resolvedProductId
    },
    domProps: {
      "value": (_vm.form.amberDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amberDays", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fba-field-hint"
  }, [_vm._v("days of stock")])]), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-field"
  }, [_c('label', [_vm._v("Alert (days)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.redDays),
      expression: "form.redDays",
      modifiers: {
        "number": true
      }
    }],
    class: ['fba-inline-input', _vm.inputFilledClass(_vm.form.redDays)],
    attrs: {
      "type": "number",
      "min": "-1",
      "placeholder": "—",
      "disabled": !_vm.resolvedProductId
    },
    domProps: {
      "value": (_vm.form.redDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "redDays", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fba-field-hint"
  }, [_vm._v("days of stock")])]), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-field"
  }, [_c('label', [_vm._v("Avg interval")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.velocityLookbackDays),
      expression: "form.velocityLookbackDays",
      modifiers: {
        "number": true
      }
    }],
    class: ['fba-inline-input', _vm.inputFilledClass(_vm.form.velocityLookbackDays)],
    attrs: {
      "type": "number",
      "min": "1",
      "placeholder": "14",
      "disabled": !_vm.resolvedProductId
    },
    domProps: {
      "value": (_vm.form.velocityLookbackDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "velocityLookbackDays", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fba-field-hint"
  }, [_vm._v("days for avg")])])]), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-actions"
  }, [_c('button', {
    staticClass: "fba-btn-save",
    attrs: {
      "type": "button",
      "disabled": _vm.saving || !_vm.resolvedProductId
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Save\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "fba-btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('span', {
    staticClass: "fba-inline-hint"
  }, [_vm._v("Leave blank to use account defaults.")])]), _vm._v(" "), (_vm.saveError) ? _c('div', {
    staticClass: "alert-thresholds-error"
  }, [_vm._v(_vm._s(_vm.saveError))]) : _vm._e(), _vm._v(" "), (_vm.saving) ? _c('div', {
    staticClass: "alert-thresholds-loading"
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" Saving…\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-261c34d7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/issues/AlertThresholdsInline.vue
// module id = 734
// module chunks = 2